<template>
  <div class="row">
    <div class="col-md-4 reports-tab-container">
      <div class="row">
        <div class="col-md-8">
          <label class="report-label">{{
            $t("reports.taxes.date_range")
          }}</label>
          <base-select
            v-model="selectedRange"
            :options="dateRange"
            :allow-empty="false"
            :show-labels="false"
            @input="onChangeDateRange"
          />
          <span
            v-if="$v.range.$error && !$v.range.required"
            class="text-danger"
          >
            {{ $t("validation.required") }}
          </span>
        </div>
      </div>
      <div class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{
            $t("reports.taxes.from_date")
          }}</label>
          <base-date-picker
            v-model="formData.from_date"
            :invalid="$v.formData.from_date.$error"
            :calendar-button="true"
            calendar-button-icon="calendar"
            @change="$v.formData.from_date.$touch()"
          />
          <span
            v-if="
              $v.formData.from_date.$error && !$v.formData.from_date.required
            "
            class="text-danger"
          >
            {{ $t("validation.required") }}
          </span>
        </div>

        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t("reports.taxes.to_date") }}</label>
          <base-date-picker
            v-model="formData.to_date"
            :invalid="$v.formData.to_date.$error"
            :calendar-button="true"
            calendar-button-icon="calendar"
            @change="$v.formData.to_date.$touch()"
          />
          <span
            v-if="$v.formData.to_date.$error && !$v.formData.to_date.required"
            class="text-danger"
          >
            {{ $t("validation.required") }}
          </span>
        </div>
      </div>

      <div v-if="userType == 'supplier'" class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="form-label">{{
            $tc("data_exports.reports.buyers")
          }}</label>
          <base-select
            v-model="formData.customer_id"
            :options="buyers"
            :group-select="false"
            :searchable="true"
            :show-labels="false"
            :placeholder="$t('clients.select_a_buyer')"
            group-values="options"
            group-label="label"
            track-by="id"
            label="name"
          />
        </div>
      </div>

      <div class="row report-submit-button-container">
        <div class="col-md-6">
          <base-button
            outline
            color="theme"
            class="report-button"
            @click="getReports()"
          >
            {{ $t("reports.update_report") }}
          </base-button>
        </div>
      </div>
    </div>
    <div class="col-sm-8 reports-tab-container">
      <iframe :src="getReportUrl" class="reports-frame-style" />
      <a
        class="base-button btn btn-primary btn-lg report-view-button"
        @click="viewReportsPDF"
      >
        <font-awesome-icon
          icon="file-pdf"
          class="vue-icon icon-left svg-inline--fa fa-download fa-w-16 mr-2"
        />
        <span>{{ $t("reports.view_pdf") }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { validationMixin } from "vuelidate";
const { required } = require("vuelidate/lib/validators");

export default {
  mixins: [validationMixin],
  data() {
    return {
      AnchorReportTypes: ["By Supplier"],
      FunderReportTypes: ["By Customer"],
      AnchorSelectedType: "By Supplier",
      FunderSelectedType: "By Customer",
      dateRange: [
        "Today",
        "This Week",
        "This Month",
        "This Quarter",
        "This Year",
        "Previous Week",
        "Previous Month",
        "Previous Quarter",
        "Previous Year",
        "Custom"
      ],
      selectedRange: "This Month",
      range: new Date(),
      formData: {
        from_date: moment()
          .startOf("month")
          .toString(),
        to_date: moment()
          .endOf("month")
          .toString(),
        company_id: null,
        customer_id: null,
        funder_id: null,
        user_id: null
      },
      url: null,
      supplierSiteURL: null,
      siteURL: null,
      itemsSiteURL: null,
      userType: null,
      newSuppliersArray: [],
      newBuyersArray: [],
      newBanksArray: []
    };
  },
  validations: {
    range: {
      required
    },
    formData: {
      from_date: {
        required
      },
      to_date: {
        required
      }
    }
  },
  computed: {
    ...mapGetters("company", ["getSelectedCompany"]),
    getReportUrl() {
      return this.url;
    },

    buyers: {
      get: function() {
        return [
          {
            label: "Buyers",
            isDisable: true,
            options: this.newBuyersArray
          }
        ];
      },
      set: function(val) {
        this.formData.customer_id = val;
      }
    },
    customers: {
      get: function() {
        return [
          {
            label: "Buyers",
            isDisable: true,
            options: this.newBuyersArray
          }
        ];
      },
      set: function(val) {
        this.formData.customer_id = val;
      }
    }
  },

  watch: {
    range(newRange) {
      this.formData.from_date = moment(newRange)
        .startOf("year")
        .toString();
      this.formData.to_date = moment(newRange)
        .endOf("year")
        .toString();
    }
  },

  created() {
    if (localStorage.getItem("role") == "super_admin") {
      this.userType = "super_admin";
    } else if (localStorage.getItem("account_type") == "funder") {
      this.userType = "funder";
      this.getBuyersForFunder();
    } else if (localStorage.getItem("account_type") == "supplier") {
      this.userType = "supplier";
      this.getBuyers();
    }
  },

  mounted() {
    this.siteURL = `/reports/tax-summary/${
      this.getSelectedCompany.unique_hash
    }`;

    this.getInitialReport();
  },
  methods: {
    ...mapActions("customer", [
      "fetchCreateCustomer",
      "fetchCustomers",
      "fetchBuyerAllSuppliersBanks"
    ]),

    ...mapActions("supplier", [
      "fetchSuppliers",
      "fetchSupplierBanks",
      "fetchBuyerBanks"
    ]),

    ...mapActions("profileSharing", ["loadProfileSharingData"]),

    ...mapActions("funder", [
      "fetchBuyersForFunder",
      "fetchSuppliersFromBuyers"
    ]),

    async getBuyers() {
      let response = await this.fetchCustomers();
      let buyersAsCustomers = response.data.customers.data;
      let selectAll = [];
      selectAll.push({ id: "all", name: "Select All" });
      buyersAsCustomers.map(function(row) {
        if (row.company_name != null) {
          selectAll.push({ id: row.id, name: row.name });
        }
      });
      this.newBuyersArray = selectAll;
    },

    async getBuyersForFunder() {
      await this.fetchBuyersForFunder().then(response => {
        let buyersArray = response.data.buyers;
        let selectAllBuyers = [];
        selectAllBuyers.push({ id: "all", name: "Select All" });
        buyersArray.map(function(row) {
          selectAllBuyers.push({ id: row.id, name: row.name });
        });
        this.newBuyersArray = selectAllBuyers;
      });
    },

    getThisDate(type, time) {
      return moment()
        [type](time)
        .toString();
    },
    getPreDate(type, time) {
      return moment()
        .subtract(1, time)
        [type](time)
        .toString();
    },
    onChangeDateRange() {
      switch (this.selectedRange) {
        case "Today":
          this.formData.from_date = moment().toString();
          this.formData.to_date = moment().toString();
          break;

        case "This Week":
          this.formData.from_date = this.getThisDate("startOf", "isoWeek");
          this.formData.to_date = this.getThisDate("endOf", "isoWeek");
          break;

        case "This Month":
          this.formData.from_date = this.getThisDate("startOf", "month");
          this.formData.to_date = this.getThisDate("endOf", "month");
          break;

        case "This Quarter":
          this.formData.from_date = this.getThisDate("startOf", "quarter");
          this.formData.to_date = this.getThisDate("endOf", "quarter");
          break;

        case "This Year":
          this.formData.from_date = this.getThisDate("startOf", "year");
          this.formData.to_date = this.getThisDate("endOf", "year");
          break;

        case "Previous Week":
          this.formData.from_date = this.getPreDate("startOf", "isoWeek");
          this.formData.to_date = this.getPreDate("endOf", "isoWeek");
          break;

        case "Previous Month":
          this.formData.from_date = this.getPreDate("startOf", "month");
          this.formData.to_date = this.getPreDate("endOf", "month");
          break;

        case "Previous Quarter":
          this.formData.from_date = this.getPreDate("startOf", "quarter");
          this.formData.to_date = this.getPreDate("endOf", "quarter");
          break;

        case "Previous Year":
          this.formData.from_date = this.getPreDate("startOf", "year");
          this.formData.to_date = this.getPreDate("endOf", "year");
          break;

        default:
          break;
      }
    },
    setRangeToCustom() {
      this.selectedRange = "Custom";
    },
    async getInitialReport() {
      this.url = `${this.siteURL}?from_date=${moment(
        this.formData.from_date
      ).format("DD/MM/YYYY")}&to_date=${moment(this.formData.to_date).format(
        "DD/MM/YYYY"
      )}`;

      return true;
    },

    async viewReportsPDF() {
      let data = await this.getReports();
      window.open(this.getReportUrl, "_blank");
      return data;
    },

    async getReports(isDownload = false) {
      this.$v.range.$touch();
      this.$v.formData.$touch();
      if (this.$v.$invalid) {
        return true;
      }
      this.url = `${this.siteURL}?from_date=${moment(
        this.formData.from_date
      ).format("DD/MM/YYYY")}&to_date=${moment(this.formData.to_date).format(
        "DD/MM/YYYY"
      )}`;

      if (this.formData.company_id && this.formData.company_id.id !== "all") {
        this.url += `&company_id=${this.formData.company_id.id}`;
      }

      if (this.formData.customer_id && this.formData.customer_id.id !== "all") {
        this.url += `&customer_id=${this.formData.customer_id.id}`;
      }

      if (this.formData.funder_id && this.formData.funder_id.id !== "all") {
        this.url += `&funder_id=${this.formData.funder_id.id}`;
      }

      if (this.formData.user_id && this.formData.user_id.id !== "all") {
        this.url += `&user_id=${this.formData.user_id.id}`;
      }

      return true;
    },
    downloadReport() {
      if (!this.getReports()) {
        return false;
      }

      window.open(this.url + "&download=true");

      setTimeout(() => {
        this.url = `${this.siteURL}?from_date=${moment(
          this.formData.from_date
        ).format("DD/MM/YYYY")}&to_date=${moment(this.formData.to_date).format(
          "DD/MM/YYYY"
        )}`;

        if (this.formData.company_id && this.formData.company_id.id !== "all") {
          this.url += `&company_id=${this.formData.company_id.id}`;
        }

        if (
          this.formData.customer_id &&
          this.formData.customer_id.id !== "all"
        ) {
          this.url += `&customer_id=${this.formData.customer_id.id}`;
        }

        if (this.formData.funder_id && this.formData.funder_id.id !== "all") {
          this.url += `&funder_id=${this.formData.funder_id.id}`;
        }

        if (this.formData.user_id && this.formData.user_id.id !== "all") {
          this.url += `&user_id=${this.formData.user_id.id}`;
        }
      }, 200);
    }
  }
};
</script>
